export const ISSUE_ABLE_DETAILS_REQUEST     = 'ISSUE_ABLE_DETAILS_REQUEST';
export const ISSUE_ABLE_DETAILS_SUCCESS     = 'ISSUE_ABLE_DETAILS_SUCCESS';
export const ISSUE_ABLE_DETAILS_FAILED      = 'ISSUE_ABLE_DETAILS_FAILED';
